import { CheckoutScreen } from '@fhs/cart';

export default CheckoutScreen;
